import EventPage from './components/EventPage'

export default EventPage
